<template>
    <main>
        <div class="header"></div>
        <div class="bg">
            <div class="top-box">
                <div class="title-box">
                    <div class="title"></div>
                    <div class="m-title"><div class="img"></div></div>
                    <div class="logo"></div>
                </div>
                <div class="logo-box">
                    <div class="box"></div>
                </div>
            </div>
            <div class="register-box">
                <div class="title">报名参会</div>
                <div class="clear item" data-name="phone">
                    <div class="left tit"><div class="middle"><i>*</i>手机号</div></div>
                    <div class="left input">
                        <input type="text" class="left in" :class="[error.phone ? 'error' : '']" @blur="validate('phone')" placeholder="手机" v-model="form.phone" :readonly="is_new == 2 ? true : false">
                        <div class="validate">{{error.phone}}</div>
                    </div>
                </div>
                <div class="clear item" data-name="code">
                    <div class="left tit"><div class="middle"><i>*</i>验证码</div></div>
                    <div class="left input code">
                        <input type="text" class="left in" :class="[error.code ? 'error' : '']" @blur="validate('code');getEdmByPhone();" placeholder="请输入验证码" v-model="form.code">
                        <span class="left btn" :class="code_status ? '' :'hidden'" @click="getCode">{{code_text}}</span>
                        <div class="validate">{{error.code}}</div>
                    </div>
                </div>
                <div class="clear item" data-name="username">
                    <div class="left tit"><div class="middle"><i>*</i>姓名</div></div>
                    <div class="left input">
                        <input type="text" class="left in" :class="[error.username ? 'error' : '']" @blur="validate('username')" placeholder="姓名" v-model="form.username" >
                        <div class="validate">{{error.username}}</div>
                    </div>
                </div>
                <div class="clear item" data-name="email">
                    <div class="left tit"><div class="middle"><i>*</i>邮箱</div></div>
                    <div class="left input">
                        <input type="email" class="left in" :class="[error.email ? 'error' : '']" @blur="validate('email')" placeholder="邮箱" v-model="form.email">
                        <div class="validate">{{error.email}}</div>
                    </div>
                </div>
<!--                <div class="clear item" data-name="password" v-show="is_new != 2">-->
<!--                    <div class="left tit"><div class="middle"><i>*</i>密码</div></div>-->
<!--                    <div class="left input">-->
<!--                        <input type="password" class="left in" maxlength="20" :class="[error.password ? 'error' : '']" @blur="validate('password')" placeholder="请输入密码" v-model="form.password">-->
<!--                        <div class="validate">{{error.password}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="clear item" data-name="password2" v-show="is_new != 2">-->
<!--                    <div class="left tit"><div class="middle"><i>*</i>确认密码</div></div>-->
<!--                    <div class="left input">-->
<!--                        <input type="password" class="left in" maxlength="20" :class="[error.password2 ? 'error' : '']" @blur="validate('password2')" placeholder="请再次确认密码" v-model="form.password2">-->
<!--                        <div class="validate">{{error.password2}}</div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="clear item" data-name="company">
                    <div class="left tit"><div class="middle"><i>*</i>单位名称</div></div>
                    <div class="left input">
                        <input type="text" class="left in" :class="[error.company ? 'error' : '']" @blur="validate('company')" placeholder="单位名称" v-model="form.company">
                        <div class="validate">{{error.company}}</div>
                    </div>
                </div>
                <!--<div class="clear item item-select" data-name="rank">
                    <div class="left tit"><div class="middle"><i>*</i>职级</div></div>
                    <div class="left input" :class="[error.rank ? 'error' : '']">
                        <dell-select :option="select_option.rank" :value="form.rank" @setValue="setValue('rank',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.rank}}</div>
                </div>
                <div class="clear item item-select" data-name="rank_type">
                    <div class="left tit"><div class="middle"><i>*</i>职能选型</div></div>
                    <div class="left input" :class="[error.rank_type ? 'error' : '']">
                        <dell-select :option="select_option.rank_type" :value="form.rank_type" @setValue="setValue('rank_type',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.rank_type}}</div>
                </div>
                <div class="clear item item-check" data-name="rank_list" v-if="form.rank_type">
                    <div class="left tit"><div class="middle"><i>*</i>职能</div></div>
                    <div class="left ll" v-for="i in rank_list" v-if="i.type == form.rank_type">
                        <label v-for="(ii,vv) in i.list"><input type="checkbox" v-model="form.rank_list" name="rank_list" :value="ii"><i></i><span>{{ii}}</span></label>
                    </div>
                    <div class="validate">{{error.rank_list}}</div>
                </div>
                <div class="clear item-wrap" data-name="province">
                    <div class="clear item item-m item-left">
                        <div class="left tit"><div class="middle"><i>*</i>省份</div></div>
                        <div class="left input" :class="[error.province ? 'error' : '']">
                            <dell-select :option="province" :value="form.province" @setValue="setValue('province',$event)"></dell-select>
                        </div>
                        <div class="validate">{{error.province}}</div>
                    </div>
                    <div class="clear item item-m" data-name="city">
                        <div class="left tit"><div class="middle"><i>*</i>城市</div></div>
                        <div class="left input" :class="[error.city ? 'error' : '']">
                            <dell-select :option="city" :value="form.city" @setValue="setValue('city',$event)"></dell-select>
                        </div>
                        <div class="validate">{{error.city}}</div>
                    </div>
                </div>
                <div class="clear item item-select" data-name="industry">
                    <div class="left tit"><div class="middle"><i>*</i>行业</div></div>
                    <div class="left input" :class="[error.industry ? 'error' : '']">
                        <dell-select :option="select_option.industry" :value="form.industry" @setValue="setValue('industry',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.industry}}</div>
                </div>
                <div class="clear item item-select" data-name="people">
                    <div class="left tit"><div class="middle"><i>*</i>公司人数</div></div>
                    <div class="left input" :class="[error.people ? 'error' : '']">
                        <dell-select :option="select_option.people" :value="form.people" @setValue="setValue('people',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.people}}</div>
                </div>
                <div class="clear item item-select item-lang">
                    <div class="left tit"><div class="middle"><i>*</i>贵公司目前是否有采购IT产品的计划</div></div>
                    <div class="left input" :class="[error.plan ? 'error' : '']">
                        <dell-select :option="select_option.plan" :value="form.plan" @setValue="setValue('plan',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.plan}}</div>
                </div>
                <div class="clear item item-select item-lang" data-name="buy">
                    <div class="left tit"><div class="middle"><i>*</i>您的预算</div></div>
                    <div class="left input" :class="[error.buy ? 'error' : '']">
                        <dell-select :option="select_option.buy" :value="form.buy" @setValue="setValue('buy',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.buy}}</div>
                </div>
                <div class="clear item item-select item-lang" data-name="product">
                    <div class="left tit"><div class="middle"><i>*</i>您感兴趣的产品</div></div>
                    <div class="left input" :class="[error.product ? 'error' : '']">
                        <dell-select :option="select_option.product" :value="form.product" @setValue="setValue('product',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.product}}</div>
                </div>
                <div class="clear item item-select item-lang" data-name="case">
                    <div class="left tit"><div class="middle"><i>*</i>您感兴趣的解决方案</div></div>
                    <div class="left input" :class="[error.case ? 'error' : '']">
                        <dell-select :option="select_option.case" :value="form.case" @setValue="setValue('case',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.case}}</div>
                </div>
                <div class="clear item item-select item-lang" data-name="role">
                    <div class="left tit"><div class="middle"><i>*</i>您在公司的决策中扮演什么样的角色</div></div>
                    <div class="left input" :class="[error.role ? 'error' : '']">
                        <dell-select :option="select_option.role" :value="form.role" @setValue="setValue('role',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.role}}</div>
                </div>
                <div class="clear item item-check item-lang" data-name="topic">
                    <div class=" tit"><div class="middle"><i>*</i>您感兴趣的会场</div></div>
                    <div class=" ll">
                        <label v-for="(ii,vv) in select_option.topic"><input type="checkbox" v-model="form.topic" name="topic" :value="ii"><i></i><span>{{ii}}</span></label>
                    </div>
                    <div class="validate">{{error.topic}}</div>
                </div>
                <div class="clear item item-select item-lang" data-name="description">
                    <div class="left tit"><div class="middle">项目描述</div></div>
                    <div class="left input">
                        <input type="text" class="left in" placeholder="项目描述" v-model="form.description">
                    </div>
                    <div class="validate"></div>
                </div>-->
                <div class="check-box item-select">
                    <div class="tit"><i class="red">*</i>更多解决方案或产品方面的问题，您是否愿意接受戴尔易安信销售/合作伙伴与您联系？</div>
                    <div class="check">
                        <label><input type="radio" v-model="form.agree_contact" name="receive_message" value="1"><i></i><span>是</span></label>
                        <label><input type="radio" v-model="form.agree_contact" name="receive_message" value="2"><i></i><span>否</span></label>
                    </div>
                    <div class="validate">{{error.agree_contact}}</div>
                </div>
                <div class="rule-box item-select" data-name="rule">
					<div class="tit">
						<label for=""><input type="checkbox" @change="validate('rule')" v-model="form.rule" name="agree"><i class="i"></i> <span>Technologies 及其公司集团（简称“戴尔”）希望与您保持联系，并及时通过电子邮件或电话/短信向您通报有关产品、服务、解决方案、专属优惠和特别活动的最新信息。有关信息处理方式的更多详细信息，请阅读我们的<i @click.prevent="util.toLink('https://www.dell.com/learn/cn/zh/cncorp1/policies-privacy','','_blank')"> 隐私声明 </i>。您可以随时取消订阅。</span>
						</label>
					</div>
                    <div class="validate">{{error.rule}}</div>
                </div>
                <div class="submit" @click="submit">立即报名</div>
            </div>
        </div>
        <div class="book-success" v-if="book_success">
            <div class="mark"></div>
            <div class="content">
                <div class="close" @click="util.toBack()"></div>
                <div class="middle">
                    <div class="title">{{book_info.title}}</div>
                    <div class="m-title" v-html="book_info.desc"></div>
                    <div class="tip">（参会链接将在会前发送到您的报名邮箱，敬请关注！）</div>
                    <div class="btn"  @click="util.toBack()">确定</div>
                </div>
            </div>
        </div>
        <service></service>
    </main>
</template>

<script>
    import DellSelect from"../../components/pc/DellSelect";
    import Service from "../../components/pc/Service";
    export default {
        name:'edm',
        data() {
            return {
                query:"",
                form:{
                    province:"",
                    agree_contact:1,
                    rank_type:"",
                    rank_list:[],
                    topic:[],
                },
                province:[],
                city:[],
                code_text:"获取验证码",
                code_status:true,
                is_new:false,
                error:{},
                book_success:false,
                book_info:{},
                logo:[require('@/assets/image/49.png'),require('@/assets/image/50.png')],
            }
        },
        components:{
            DellSelect,Service
        },
        computed:{
            select_option(){
                return {
                    rank:["高级管理层","管理层","工程师/技术专家","其他"],
                    rank_type:["信息技术","高级行政","财务/采购","生产运维","办公室行政","客服/技术支持","媒体/出版","其他"],

                    industry:["互联网相关企业","IT服务业","物流运输业","其他服务行业","高科技制造业","普通制造业","金融行业","批发零售业","电信","媒体、娱乐","能源","政府、事业单位","医疗行业","教育行业","房地产","其他"],
                    people:['1-25','26-99','100-499','500-999','1000-4999','5000-9999','10000+'],
                    plan:['<3 月','3-6 月','6-12 月','>12 月',"无计划"],
                    buy:["5万以下","5万-10万","10万-30万","30万-50万","50万-100万","100万以上","无计划"],
                    product:["商用笔记本","商用台式机","工作站","服务器","网络交换机","数据存储","数据保护","超融合架构","显示器及外设设备"],
                    case:["云计算","软件定义","大数据","融合/超融合","数据库加速","高性能计算","业务连续性","桌面虚拟化","数据保护","咨询服务","VR解决方案","灵活桌面解决方案","移动办公解决方案","智能会议解决方案","戴尔硬盘保护套件",],
                    role:["决策者","影响者","建议者",],
                    topic:["主会场","主题分论坛-智能办公","主题分论坛-数据","主题分论坛-算力","主题分论坛-云计算","主题分论坛-边缘侧","主题分论坛-人工智能","行业应用分论坛-医疗","行业应用分论坛-教育","行业应用分论坛-制造业","行业应用分论坛-金融"]
                }
            },
            rank_list(){
                return [
                    {type:"信息技术",list:['硬件管理及维护', '网络管理及维护', '桌面运维', 'IT架构设计', '应用软件研发', '软件管理/维护', '信息安全/保护/灾备', 'DBA/数据库', '数据中心/数据中台', '数据建模/挖掘/分析', '大数据架构', '项目管理', 'BI/商业智能', '人工智能', '通讯', '其他']},
                    {type:"高级行政",list:['董事会', 'CEO', '总裁', '总经理', '其他']},
                    {type:"财务/采购",list:['财务', '采购', '供应商管理', '其他']},
                    {type:"生产运维",list:['供应链管理', '产线管理', '质量监控', '其他']},
                    {type:"办公室行政",list:['办公室主任', '总裁助理/总经理助理/董事会秘书', '行政总监/经理', '其他']},
                    {type:"客服/技术支持",list:['售前技术支持', '售后技术支持', '实施顾问', '咨询热线/呼叫中心', '客户服务', '其他']},
                    {type:"媒体/出版",list:['编辑', '记者', '出版发行', '其他']},
                    {type:"其他",list:['其他']},
                ]
            },
            form_province(){
                return this.form.province;
            },
            form_rank_type(){
                return this.form.rank_type;
            },
            form_rank_list(){
                return this.form.rank_list;
            },
            form_topic(){
                return this.form.topic;
            }
        },
        watch:{
            form_rank_type(){
                this.form.rank_list = [];
            },
            form_rank_list(newVal,OldVal){
                if(newVal.length != OldVal.length){
                    this.validate('rank_list');
                }
            },
            form_topic(newVal,OldVal){
                if(newVal != OldVal){
                    this.validate('topic');
                }
            }
        },
        methods: {
            reload(){
                window.location.reload();
            },
            getEdmByPhone(){
                if(!this.is_new){
                    this.setError('code','验证码错误');return false;
                }
                if(this.is_new == 1){return false;}
                if(this.validate('phone') && this.validate('code')){
                    this.http.request({
                        api:"auth/getEdmByPhone",
                        data:{
                            phone:this.form.phone,
                            code:this.form.code
                        },
                        loading:true,
                        success:(res)=>{
                            var user_thumb = res.user;
                            //this.form.username = user_thumb.name;
                            //this.form.phone = user_thumb.mobile;
                            // this.form.email = user_thumb.email;
                            // this.form.company = user_thumb.enterprise_name;
                            this.form.rank = user_thumb.joblevel ? user_thumb.joblevel[0] :'';
                            this.form.rank_type = user_thumb.jobfunction ? user_thumb.jobfunction[0] :'';
                            this.form.province = user_thumb.province && user_thumb.province[0] ?{title: user_thumb.province[0]} :'';
                            this.form.city = user_thumb.province && user_thumb.province[1] ? {title:user_thumb.province[1]} : '';
                            this.form.industry = user_thumb.industry ? user_thumb.industry[0] : '';
                            this.form.people = user_thumb.employeesNumber ? user_thumb.employeesNumber[0] :'';
                            this.form.plan = user_thumb.m_buyPlan ? user_thumb.m_buyPlan[0] : '';
                            this.form.buy = user_thumb.m_buyBudget ? user_thumb.m_buyBudget[0] : '';
                            this.form.product = user_thumb.m_interestProduct ? user_thumb.m_interestProduct[0] : '';
                            this.form.case = user_thumb.m_solutionType ? user_thumb.m_solutionType[0] : '';
                            this.form.role = user_thumb.m_companyRole ? user_thumb.m_companyRole[0] : '';
                            this.form.description = user_thumb.m_isummary;

                            this.form.password = user_thumb.password;
                            this.form.memberId = user_thumb.memberId;
                            this.form.loginId = user_thumb.loginId;
                            this.form.session = user_thumb.session;
                            this.form.sess = user_thumb.sess;
                            this.$forceUpdate();
                            this.$nextTick(()=>{
                                this.form.rank_list = user_thumb.jobfunctionrole && this.tool.type.isArray(user_thumb.jobfunctionrole) ? user_thumb.jobfunctionrole[0].split(',') : [];
                                this.$forceUpdate();
                                this.error = {};
                            })
                        },
                        error:(res)=>{
                            if(res.msg == '已报名'){
                                this.util.setAccessToken(res.data.access_token);
                                this.userInfo();
                            }else{
                                this.$toast.fail(res.msg);
                            }
                        }
                    })
                }
            },
            validate(field,name = ""){
                var message = "";
                switch (field) {
                    case 'phone':
                        if(!this.form.phone){
                            message = "请输入手机号";
                        }else if(this.isCn() && !this.tool.type.checkStr(this.form.phone,'phone') ){
                            message = "请输入正确的手机号";
                        }else{
                            message = "";
                        }
                        break;
                    case 'code':
                        if(!this.form.code){
                            message = "请输入验证码";
                        }else if(this.form.code.length != 6){
                            message = '验证码不正确';
                        }else{
                            message = "";
                        }
                        break;
                    case 'username':
                        if(!this.form.username){
                            message = "请输入姓名";
                        }else{
                            message = "";
                        }
                        break;
                    case 'email':
                        if(!this.form.email){
                            message = "请输入邮箱";
                        }else if(!this.tool.type.checkStr(this.form.email,'email')){
                            message = "请输入正确的邮箱";
                        }else{
                            message = "";
                        }
                        break;
                    case 'password':
                        if(!this.form.password){
                            message = "请输入密码";
                        }else if(this.form.password.length < 6){
                            message = "请输入6-20个字符";
                        }else{
                            message = "";
                        }
                        break;
                    case 'password2':
                        if(!this.form.password2){
                            message = "请再次确认密码";
                        }else if(this.form.password !== this.form.password2){
                            message = "两次输入的密码不一致";
                        }else{
                            message = "";
                        }
                        break;
                    case 'company':
                        if(!this.form.company){
                            message = "请输入单位名称";
                        }else{
                            message = "";
                        }
                        break;
                    case 'select':
                        if(!this.form[name]){
                            message = "请选择";
                        }else{
                            message = "";
                        }
                        break;
                    case 'rule':
                        if(!this.form.rule){
                            message = "请先阅读并同意戴尔隐私声明和销售条款";
                        }else{
                            message = "";
                        }
                        break;
                    case 'rank_list':
                        if(this.form.rank_list && this.form.rank_list.length <= 0){
                            message = "请选择";
                        }else{
                            message = "";
                        }
                        break;
                    case 'topic':
                        if(this.form.topic && this.form.topic.length <= 0){
                            message = "请选择";
                        }else{
                            message = "";
                        }
                        break;
                    default:
                        break;
                }
                this.setError(name ? name : field,message);
                return message ? false : true;
            },
            validateAll(){
                var phone = this.validate("phone");
                var code = this.validate('code');
                var username = this.validate('username');
                var email = this.validate('email');
                var password = this.validate('password');
                var password2 = this.validate('password2');
                var company = this.validate('company');
                var rank = this.validate('select','rank');
                var rank_type = this.validate('select','rank_type');
                var rank_list = this.validate('rank_list');
                var province = this.validate('select','province');
                var city = this.validate('select','city');
                var industry = this.validate('select','industry');
                var people = this.validate('select','people');
                var plan = this.validate('select','plan');
                var buy = this.validate('select','buy');
                var product = this.validate('select','product');
                var cases = this.validate('select','case');
                var role = this.validate('select','role')
                var topic = this.validate('topic')
                var rule = this.validate('rule')
                if(this.is_new == 2){
                    //if(!phone || !code || !username || !email || !company || !province || !rank || !rank_type || !rank_list || !city || !industry || !people || !plan || !buy || !product || !cases || !role || !topic || !rule ){
                    if(!phone || !code || !username || !email || !company || !rule ){
                        this.$nextTick(()=>{
                            this.scrollError();
                        })

                        return false;
                    }else{
                        return true;
                    }
                }else{
                    //if(!phone || !code || !username || !email || !password || !password2 || !company || !province || !rank || !rank_type || !rank_list || !city || !industry || !people || !plan || !buy || !product || !cases || !role || !topic || !rule ){
                    if(!phone || !code || !username || !email || !company || !rule ){
                        this.$nextTick(()=>{
                            this.scrollError();
                        })
                        return false;
                    }else{
                        return true;
                    }
                }
            },
            scrollError(){
                var list = $('.validate');
                for(var i =0;i<list.length;i++){
                    if($(list[i]).text().length > 0){
                        $('body,html').scrollTop($(list[i]).parent().offset().top-100)
                        break;
                    }
                }
            },
            setError(name,message =""){
                this.error[name] = message;
                this.$forceUpdate();
            },
            submit(){
                if(!this.is_new){
                    this.setError('code','验证码错误');return false;
                }
                var form = this.form;
                form.province_title = this.form.province ? this.form.province.title : '';
                form.city_title = this.form.city ? this.form.city.title :'';
                form.url = window.location.href;
                form.guest_id = this.util.getGuestUid();

                if(this.tool.storage.getLocal('channel')){
                    form.channel = this.tool.storage.getLocal('channel');
                }

                var res = this.validateAll();
                if(!res){return false;}

                var api = "auth/registerForEn";
                if(this.isCn()){
                    api = "auth/register";
                }

                gio('track', 'DTF2021_Submit', {
                    //'userName':form.username,
                    'phoneNumber':this.util.encryptPhone(form.phone),
                    // 'company' : form.company,
                    // 'email' :form.email,
                });

                this.http.request({
                    api:api,
                    data:form,
                    loading:true,
                    success:(res)=>{
                        this.book_info = {
                            title:"恭喜您报名成功",
                            desc:"期待您在2021年11月10日参加<br/>新·生万物 数实新格局｜2023 戴尔科技峰会",
                        }
                        this.book_success = true;
                        this.util.setAccessToken(res.access_token);
                        this.http.request({
                            api:'user/getUserInfo',
                            success:(res)=>{
                                this.$store.commit('setUserInfo',res.user);
                                this.util.setDellCookie();
                            }
                        })
                    },
                    error:(res)=>{
                        this.$toast.fail(res.msg);
                    }
                })
            },
            getUserInfo(){
                this.http.request({
                    api:'user/getUserInfo',
                    loading:true,
                    success:(res)=>{
                        this.$store.commit('setUserInfo',res.user);
                        this.util.setDellCookie();
                        this.util.toLink('/')
                    }
                })
            },
            setValue(key,value){
                this.form[key] = value;
                if(key == 'province'){
                    this.form.city = "";
                    this.city = [];
                    if(value){
                        this.getCity();
                    }
                }
                this.validate('select',key);
                this.$forceUpdate();
            },
            getProvince(){
                this.http.request({
                    api:"area/dell_province",
                    success:(res)=>{
                        this.province = res.province;
                    }
                })
            },
            getCity(){
                this.http.request({
                    api:"area/dell_city",
                    data:{
                        province_id:this.form.province.id
                    },
                    success:(res)=>{
                        this.city = res.city;
                    }
                })
            },
            checkNewUser(callback){
                var phone = this.validate("phone");
                if(!phone){return false;}
                this.http.request({
                    api:"user/checkNewUser",
                    data:{
                        phone:this.form.phone,
                        guest_id:this.util.getGuestUid()
                    },
                    //loading:true,
                    success:(res)=>{
                        this.is_new = res.is_new;
                        callback.call();
                    }
                })
            },
            getCode(){
                if(!this.code_status){return false;}
                var phone = this.validate("phone");
                if(!phone){
                    return  false;
                }

                this.cutTime();
                this.checkNewUser(()=>{
                    if(!this.is_new){return false;}

                    var api = "sms/registerForEn";
                    if(this.isCn()){
                        api = "sms/register"
                    }
                    if(this.is_new == 2){
                        api = "sms/loginForEn";
                        if(this.isCn()){
                            api = "sms/login"
                        }
                    }
                    this.http.request({
                        api:api,
                        data:{
                            phone:this.form.phone
                        },
                        //loading:true,
                        success:(res)=>{
                            //this.cutTime();
                        },
                        error:(res)=>{
                            this.setError('phone',res.msg)
                            clearInterval(this.timer);
                            this.code_text = "获取验证码"
                            this.code_status = true;
                        }
                    })
                });
            },
            cutTime(){
                this.code_status = false;
                var number = 59;
                this.code_text = "重新获取("+number+"s)";
                this.timer = setInterval(()=>{
                    number = number -1;
                    if(number <= 0){
                        clearInterval(this.timer);
                        this.code_text = "获取验证码"
                        this.code_status = true;
                    }else{
                        this.code_text = "重新获取("+number+"s)";
                    }
                },1000)
            },
            isCn(){
                return true;
            },
            userInfo(){
                if(!this.util.getAccessToken()){
                    return false;
                }
                this.http.request({
                    api:'user/getUserInfo',
                    success:(res)=>{
                        this.$store.commit('setUserInfo',res.user);
                        this.util.setDellCookie();
                        this.book_info = {
                            title:"您已报名",
                            desc:"期待您在2021年11月10日参加<br/>新·生万物 数实新格局｜2023 戴尔科技峰会",
                        }
                        this.book_success = true;
                    }
                })
            },
        },
        mounted() {
            this.query = this.$route.query;
            this.getProvince();
            //this.userInfo();
            this.util.showBottom(true);
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .header{position: fixed;top:0;left:0;width: 100%;height:80px;text-align: center;color: #fff;border-bottom: 1px solid rgba(255,255,255,.2);z-index: 99;background: url("~@/assets/image/20.jpg") no-repeat center top;background-size: 100%;display: none;}
    .bg{background:#126399 url("~@/assets/image/20.jpg") no-repeat top center;background-size:cover;padding-bottom: 50px;
        .top-box{text-align: center;
            .title-box{display: inline-block; padding-top: 150px;text-align: right;color: #fff;position: relative;
                .title{width: 970px;height:371px;background: url("~@/assets/image/0.png") no-repeat center center;background-size: contain;margin:-80px auto 0;}
                .m-title{width: 970px;margin:-130px auto 0;
                    .img{width: 326px;height:30px;margin-right: 120px; background: url("~@/assets/image/83.png") no-repeat center center;background-size:contain;float: right;}
                }
                .logo{position: absolute;top:105px;right:0;width: 178px;height:40px;background: url("~@/assets/image/logo2.png") no-repeat center center;background-size: contain;}
            }
            .logo-box{width: 960px;margin: 30px auto;color: #fff;text-align: left;
                .box{width: 240px;height:64px;background: url("~@/assets/image/82.png") no-repeat center center;background-size: contain; }
            }
        }

        .register-box{width: 960px;background: #fff;margin: 10px auto 0;border-radius: 5px;padding-bottom: 50px;
            .title{height:70px;line-height: 70px;text-align: center;font-size: 18px;border-bottom: 2px solid #f6f6f6;position: relative;margin-bottom: 34px;}
            .title::after{content:"";position: absolute; display: block;bottom:-2px;left:50%;width: 150px;height:4px;margin-left: -75px;background: #41b6e6;}
            .item-wrap{clear: both;
                .validate{margin-left:110px;}
            }
            .item{width: 830px;margin: 0 auto;
                .tit{ width: 120px;padding-right: 10px;font-size: 14px;line-height: 20px;
                    .middle{height:40px; width: 120px;text-align: right;
                        i{color: #ff0000;margin-right: 2px;}
                    }
                }
                .input{width: 630px;
                    .in{display: block; width: 600px;height:40px;padding: 0 15px;font-size: 14px; border-radius: 5px;background: #fafafa;border: 1px solid #f1f1f1;}
                    .in.error{border-color: red;}
                }
                .input.error{border: 1px solid red;box-sizing: border-box;border-radius: 5px;}
                .input.code{
                    .in{width: 440px;}
                    .btn{display: block;float: right; width: 150px;font-size: 14px;border-radius: 5px;text-align: center;line-height: 42px;background: #41b6e6;color:#fff;cursor: pointer;}
                    .btn.hidden{background: #999999;}
                }
                .validate{clear: both; height:30px;line-height: 30px;font-size:14px;color:red;}
            }
            .item.item-check{
                .ll{width: 630px;padding-top: 5px;
                    label{display: block;float: left; margin-right: 30px;height:30px;line-height: 30px;cursor: pointer;
                        input{margin-right:5px;display: none;}
                        span{display: block;float: left;}
                        input[type=checkbox]+i{display: block;float: left;width: 30px;height:30px;background: url("~@/assets/image/a4.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                        input[type=checkbox]:checked+i{background: url("~@/assets/image/a3.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                    }
                }
                .validate{margin-left:130px;}
            }
            .item.error{
                .input{
                    .in{border-color: red;}
                }
            }
            .item.item-m{float: left;width:375px;
                .tit{width: 105px;}
                .input{width:250px;
                    .in{width: 230px;}
                }
            }
            .item.item-m.item-left{padding-left:80px;}
            .item.item-select{
                .validate{margin-left:130px;}
            }
            .item.item-lang{
                .tit{float: none;width: 100%;margin-left: 130px;
                    .middle{width: 100%;height:30px;}
                }
                .input{float: none;margin-left: 130px;}
                .validate{}
            }
            .item.item-check.item-lang{
                .ll{margin-left: 130px;overflow: hidden}
            }
            .check-box{padding-left: 80px; width: 640px;margin: 0 auto 24px;
                .tit{font-size: 15px;line-height: 21px;
                    .red{color:red;margin-right: 2px;}
                }
                .check{overflow: hidden;margin-top: 10px;
                    label{margin-right: 50px;height:30px;line-height: 30px;cursor: pointer;overflow: hidden;display: block;float: left;
                        input{margin-right:10px;width: 18px;height:18px;float: left;margin-top: 5px;display: none;}
                        input[type=radio]+i{display: block;float: left; width: 30px;height:30px;background: url("~@/assets/image/a2.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                        input[type=radio]:checked+i{background: url("~@/assets/image/a1.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                        span{display: block;float: left;}
                    }
                }
            }
            .rule-box{padding-left: 80px; width: 640px;margin: 0 auto 24px;
                .tit{font-size: 15px;line-height: 30px;overflow: hidden;
                    input{margin-right: 5px;cursor: pointer;width: 18px;height:18px;margin-top: 5px; float: left;display:none;}
                    span{display: block;float: left;width: 600px;}
                    i{color:#0176ce;text-decoration: underline !important;cursor: pointer;}
                    input[type=checkbox]+.i{display: block;float: left;width: 30px;height:30px;background: url("~@/assets/image/a4.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                    input[type=checkbox]:checked+.i{background: url("~@/assets/image/a3.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                    .red{color:red;text-decoration: none !important;cursor: default;margin-right: 2px;}
                }
                .validate{clear: both;padding-left: 30px; height:30px;line-height: 30px;font-size:14px;color:red;}
            }
            .submit{width:362px;margin: 30px auto ;height:45px;line-height: 45px;text-align: center;color: #fff;font-size: 18px; background: #0176ce;border-radius: 5px;box-shadow: 0 0 10px 5px rgba(1,118,206,.1);cursor: pointer;transition: all .3s ease;}
            .submit:hover{color: #000;transition: all .3s ease;}
        }
    }
    .book-success{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 1000;
        .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8);}
        .content{position: absolute;left:50%;top:50%;width:750px;height:390px;background: url("~@/assets/image/2025/bg-success.png") no-repeat center center;background-size: cover;color: #fff;margin-left:-375px;margin-top:-195px;border-radius: 10px;
            .close{width: 50px;height:50px;position: absolute;top:0;right:0;background: url("~@/assets/image/54.png") no-repeat center center;background-size: 20px;cursor: pointer;transition: background .3s ease;display: none;}
            .close:hover{background-image:url("~@/assets/image/53.png");background-size: 20px; transition: background .3s ease;}
            .middle{width: 750px;height:390px;text-align: center;
                .title{font-size: 43px;}
                .m-title{font-size: 30px;margin-top: 30px;line-height: 46px;}
                .tip{margin-top: 20px;font-size: 18px;}
                .btn{width:140px;height:50px;text-align: center;line-height:50px;color:#fff;margin:30px auto 0;background: #2d75bc;cursor: pointer;border-radius: 5px;display: none;}
            }
        }
    }
</style>

